import React from 'react';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { connect } from 'react-redux';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { getDateFormat, suitableTime } from '../../utils/suitableDate';
import { displayPriceFormat } from '../../utils/tools';
import { SUITABLE_PAYMENT_TYPES } from '../../constants';

function DetailsPayments ({ detailsPayments }) {
  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='center'>Montant</TableCell>
            <TableCell align='center'>Moyen de paiement</TableCell>
            <TableCell align='center'>Date du paiement</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detailsPayments &&
              detailsPayments
                .sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate))
                .map((e, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell align='center'>{displayPriceFormat(e.price.toFixed(2))}</TableCell>
                      <TableCell align='center'>{SUITABLE_PAYMENT_TYPES[e.type]}</TableCell>
                      <TableCell align='center'>{` ${getDateFormat(e.orderDate)} à ${suitableTime(
                        moment(e.orderDate)
                      )} `}</TableCell>
                    </TableRow>
                  );
                })}
        </TableBody>
      </Table>
    </div>
  );
  
}

const mapStateToProps = ({ user, finances }) => {
  const { servicePrice = {} } = user;
  const { selectedEntity } = finances;
  return {
    detailsPayments: finances[selectedEntity].details,
    contract: servicePrice.fees ? servicePrice.fees.contract : null,
    paymentFees: servicePrice.fees ? servicePrice.fees.stripe : null
  };
};

export default connect(mapStateToProps, {})(DetailsPayments);
